/**
 * Session time ranges used by TreatmentSlotConfig and SchedulerView.
 * Morning: 6 AM - 12 AM, Afternoon: 12 PM - 4 PM, Evening: 4 PM - 8 PM
 */
export const SESSION_TIME_RANGES = {
    Morning: { start: { hour: 6, minute: 0 }, end: { hour: 12, minute: 0 } },
    Afternoon: { start: { hour: 12, minute: 0 }, end: { hour: 16, minute: 0 } },
    Evening: { start: { hour: 16, minute: 0 }, end: { hour: 20, minute: 0 } },
};

export const SESSION_OPTIONS = ['Morning', 'Afternoon', 'Evening'];

/** Normalize API session string to match SESSION_TIME_RANGES keys */
export function normalizeSession(session) {
    if (!session || typeof session !== 'string') return null;
    const s = session.trim();
    if (/^morning$/i.test(s)) return 'Morning';
    if (/^afternoon$/i.test(s)) return 'Afternoon';
    if (/^evening$/i.test(s)) return 'Evening';
    if (SESSION_TIME_RANGES[s]) return s;
    return null;
}
